<template>
  <div class="section-nav">
    <h2 v-html="this.$store.state.menu.currentSectionTitle"></h2>
    <div class="nav-items">
      <router-link
        v-for="(item, index) in this.$store.state.menu.currentSectionNavigation"
        :data-aos-delay="index*300"
        data-aos="zoom-in-up"
        data-aos-anchor-placement="top-bottom"
        data-aos-duration="1000"
        data-aos-easing="ease-out-cubic"
        :key="item.url"
        :to="item.url"
      >{{item.title}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionNav",
  props: {
    navigation: Array
  }
};
</script>

<style lang="scss" scoped>
.section-nav {
  display: inline-block;
  margin-left: 15px;
  position: absolute;
  top: calc(50% + 10px);
  white-space: nowrap;
  z-index: 1;
}
h2 {
  font-size: 42px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: bold;
  text-transform: uppercase;
}
.nav-items {
  position: relative;
  left: 0;
  top: 5px;
  height: 25px;
  a {
    pointer-events: all;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 20px;
    color: #fff;
    letter-spacing: 0;
    line-height: 32px;
    &:not(:last-child) {
      margin-right: 20px;
    }
    &.is-active {
      color: #ff5100;
    }
  }
}
</style>